import { useEffect, useState } from 'react';
import { supabase } from './supabase';

// What a reveal costs, in credits.
//
// The source of truth is reveal_price() in migration 022 — these values are
// only what we show before the RPC answers, and if that migration has not been
// applied yet. Repricing happens in SQL; the UI follows.
export const FALLBACK_REVEAL_PRICES = { email: 1, phone: 5, company_phone: 1 };

// Memoized at module scope: the RPC is hit once per page load no matter how
// many rows render a reveal control.
let pricesPromise = null;

export function getRevealPrices() {
  if (!pricesPromise) {
    pricesPromise = supabase
      .rpc('get_reveal_prices')
      .then(({ data, error }) => (error || !data ? FALLBACK_REVEAL_PRICES : data))
      .catch(() => FALLBACK_REVEAL_PRICES);
  }
  return pricesPromise;
}

export function useRevealPrices() {
  const [prices, setPrices] = useState(FALLBACK_REVEAL_PRICES);
  useEffect(() => {
    let active = true;
    getRevealPrices().then((p) => active && setPrices(p));
    return () => {
      active = false;
    };
  }, []);
  return prices;
}
